import { EntityChip, TableColumn, Tooltip } from '@silverfort/sf-components';
import {
    ServiceAccountsParsedTupleFilters,
    ServiceAccountTuple,
    ServiceAccountsTuplesFilters
} from './ServiceAccountsTuplesTypes';
import { bigNumberToText } from '../../../../../../../components/utils';
import { DateFormat, formatDate } from '../../../../../../../utils/dates';
import { PROTOCOL_DISPLAY_MAPPER } from '@silverfort-nodelibs/common/utils/consts';
import { TableStringListColumn } from '../../../../../../../sharedComponents/TableStringListColumn';

export const mapToParsedTupleFilters = (filters: ServiceAccountsTuplesFilters): ServiceAccountsParsedTupleFilters => {
    const parsedFilters: ServiceAccountsParsedTupleFilters = {};

    if (filters.protocols) {
        parsedFilters.protocols = filters.protocols;
    }
    if (filters.lastUsedDays) {
        parsedFilters.lastUsedDays = filters.lastUsedDays;
    }
    if (filters.sources) {
        if (filters.sources.ips.length > 0) {
            parsedFilters.source_ip = filters.sources.ips;
        }
        if (filters.sources.resources.length > 0) {
            parsedFilters.source_guid = filters.sources.resources.map((res) => res.guid);
        }
    }
    if (filters.destinations) {
        if (filters.destinations.ips.length > 0) {
            parsedFilters.destination_ip = filters.destinations.ips;
        }
        if (filters.destinations.resources.length > 0) {
            parsedFilters.destination_guid = filters.destinations.resources.map((res) => res.guid);
        }
    }

    return parsedFilters;
};

export const COLUMNS: TableColumn<ServiceAccountTuple>[] = [
    {
        columnKey: 'source',
        title: 'Source'
    },
    {
        columnKey: 'destination',
        title: 'Destination'
    },
    {
        columnKey: 'protocols',
        disableSort: true,
        title: 'Protocols',
        render: ({ protocols }) => {
            const protocolNames = protocols.map((protocol) => PROTOCOL_DISPLAY_MAPPER[protocol] || protocol);
            return <TableStringListColumn list={protocolNames} />;
        }
    },
    {
        columnKey: 'services',
        disableSort: true,
        title: 'Services',
        render: ({ services }) => <TableStringListColumn list={services.map((service) => service.name)} />
    },
    {
        columnKey: 'successCount',
        title: 'Authentications',
        render: ({ successCount, failCount }) => (
            <Tooltip
                title={
                    <div>
                        <div>{`Successful: ${bigNumberToText(successCount)}`}</div>
                        <div>{`Failed: ${bigNumberToText(failCount)}`}</div>
                    </div>
                }>
                <span>{bigNumberToText(successCount + failCount)}</span>
            </Tooltip>
        )
    },
    {
        columnKey: 'firstUse',
        title: 'First seen',
        render: ({ firstUse }) => formatDate(firstUse, DateFormat.SHORT_DATE_MD, true)
    },
    {
        columnKey: 'lastUse',
        title: 'Last seen',
        render: ({ lastUse }) => formatDate(lastUse, DateFormat.SHORT_DATE_MD, true)
    }
];
